import {motion} from 'framer-motion';
import {waLink} from '../data/whatsapp';

const images=[
  'https://images.unsplash.com/photo-1534438327276-14e5300c3a48?auto=format&fit=crop&w=800&q=85',
  'https://images.unsplash.com/photo-1517836357463-d25dfeac3438?auto=format&fit=crop&w=800&q=85',
  'https://images.unsplash.com/photo-1576678927484-cc907957088c?auto=format&fit=crop&w=800&q=85',
  'https://images.unsplash.com/photo-1517344884509-a0c97ec11bcc?auto=format&fit=crop&w=800&q=85',
  'https://images.unsplash.com/photo-1544367567-0f2fcb009e0b?auto=format&fit=crop&w=800&q=85',
  'https://images.unsplash.com/photo-1567013127542-490d757e51fc?auto=format&fit=crop&w=800&q=85',
];

function Gallery() {
  return (
    <section className="gallery-section" id="gallery">
      <div className="section-head center">
        <span className="eyebrow">Inside the club</span>
        <h2>A look<br /><em>around.</em></h2>
      </div>
      <div className="gallery-grid">
        {images.map((img,i)=> (
          <motion.a
            href={waLink('I would love a tour of the facility.')}
            target="_blank"
            rel="noreferrer"
            className="gallery-item"
            key={i}
            style={{backgroundImage: `url(${img})`}}
            initial={{opacity: 0,scale: 0.95}}
            whileInView={{opacity: 1,scale: 1}}
            viewport={{once: true}}
            transition={{delay: (i % 3) * 0.1,duration: 0.5}}
          >
            <span className="gallery-tag">Forge Fitness</span>
          </motion.a>
        ))}
      </div>
      <a
        className="button button-lime center-btn"
        href={waLink('I would like to book a facility tour.')}
        target="_blank"
        rel="noreferrer"
        style={{display: 'flex',width: 'fit-content',maxWidth: 'calc(100% - 2rem)',margin: '40px auto 0'}}
      >
        Book a tour ↗
      </a>
    </section>
  );
}

export default Gallery;
